function currenttime_provider(data = "", options) {
    try {
        // Set default options and merge with user-provided options
        const defaultOptions = { increase: 0, mode: "today" };
        options = { ...defaultOptions, ...options }; // Merge defaults with provided options
        // Use today's date if input is empty or invalid
        const today = data ? new Date(data) : new Date();

        // Adjust the date by the increase or decrease in days
        today.setDate(today.getDate() + options.increase);

        // Extract year, month, and day
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months are 0-based
        let dd = today.getDate();

        // Add leading zeros for consistency
        if (mm < 10) mm = "0" + mm;
        if (dd < 10) dd = "0" + dd;
        // Determine output based on the mode
        switch (options.mode) {
            case "firstDayOfWeek": {
                const day = today.getDay();
                const diff = day === 0 ? -6 : 1 - day; // Adjust to Monday (start of the week)
                today.setDate(today.getDate() + diff);
                break;
            }
            case "lastDayOfWeek": {
                const day = today.getDay();
                const diff = day === 0 ? 0 : 7 - day; // Adjust to Sunday (end of the week)
                today.setDate(today.getDate() + diff);
                break;
            }
            case "yesterday": {
                today.setDate(today.getDate() - 1); // Move back 1 day
                break;
            }
            case "firstDayOfMonth": {
                today.setDate(1); // Set to the first day of the current month
                break;
            }
            case "lastDayOfMonth": {
                today.setMonth(today.getMonth() + 1); // Move to the next month
                today.setDate(0); // Set to the last day of the previous month
                break;
            }
            case "firstDayOfYear": {
                today.setMonth(0); // Set to January
                today.setDate(1); // Set to the 1st day
                break;
            }
            case "lastDayOfYear": {
                today.setMonth(11); // Set to December
                today.setDate(31); // Set to the last day
                break;
            }
            case "today":
            default:
                break; // Keep the adjusted "today" value
        }

        // Format the output
        const formattedDate = `${yyyy}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
        return formattedDate;
    } catch (error) {
        console.log(error,"error")
    }

}


export { currenttime_provider }